import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { customerProvider } from "../../contexts/CustomerContext";
import { userProvider } from "../../contexts/UserContext";
import ShopNavbar from "./StoreComponents/ShopNavbar";
import StoreFooter from "./StoreComponents/StoreFooter";
import PhoneInput from "react-phone-input-2";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import LoadingSpinner from "../../components/utils/LoadingSpinner";
import { domainProvider } from "../../contexts/DomainContext";
import { storeInformation } from "../../contexts/StoreInformationContext";
import axios from "axios";
import LoginComponent from "./AuthComponent/LoginComponent";
import RegisterCompinent from "./AuthComponent/RegisterComponent";
import Div from "../../components/utils/Div";

const RegisterLogin = () => {

  const [loading, setLoading] = useState(false);
  
      const { t } = useTranslation();


  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <ShopNavbar />
      <Div>
      <div className="Container">
        <div className="px-5 mt-12 mb-40 grid grid-cols-1 lg:grid-cols-2 gap-8 ">
          {/* login page */}
          <div>
            <h1 className="text-center text-2xl mb-2">{t("HNav_login")}</h1>
            <LoginComponent />
          </div>

          {/* registration page */}
          <div>
            <h1 className="text-center text-2xl mb-2">{t("regi_btn")}</h1>
            <RegisterCompinent />
          </div>
        </div>
      </div>
      </Div>
      <StoreFooter />
    </div>
  );
};

export default RegisterLogin;
